import React, { Component } from 'react'
import {Button, Menu, Input, Badge, List, Divider, Modal, Select, message, Tag} from 'antd';
import Axios from 'axios'
import { connect } from 'react-redux';
import Header4 from 'src/components/Header/Header4'
import icon_search from './img/icon_search.png'
import icon_add from './img/icon_add.png'
import './index.css'
import { JudgingSpeech } from './JudgingSpeech';

const { Option } = Select;
const { TextArea } = Input;

class QACenter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            postList: [],
            total:0,
            page: 1,
            sortType: '时间',
            inputValue: '',
            selectType: '',
            modalVisible: false,
            postTitle: '',
            postType: '',
            postContent: '',
            selectedValue: undefined,
            isLoading: false,
        }
    }

    componentDidMount() {
        this._getPageOfPost(10, 1)
    }


    _getPageOfPost = (pageSize, pageNum, keyword = '', type = '', orderType = '') => {
        Axios.get(global.url.wd + "/postV2/selectByKeyword?limit=" + pageSize + '&page=' + pageNum + '&keyword=' + (keyword ? keyword : '') + '&postType=' + type + '&orderType=' + orderType).then((response) => {
            if (response.data.code === '200') {
                let { records,total} = response.data.payload
                this.setState({
                    postList: records,
                    total
                })
            }
            // var data = response.data.data
            // this.refs.wdlist.setState({
            //     current: page,
            //     QAlist: data.list,
            //     total: data.totalCount
            // });
            // dtd.resolve(); // 改变Deferred对象的执行状态
        }).catch(() => {
            // dtd.reject()
        })
    }

    _renderPost = item => {

        return (
            <List.Item
                key={item.postId}
                onClick={() => this.props.history.push({
                    pathname: '/Q&ADetail/' + item.postId,
                    state: item
                })}
            >
                <div className='postTitleContainer'>
                    <span className='postTitle'>{item.postTitle}</span>
                    {/*<div className='postType'>
                        <span className='postTypeText'>
                            {item.postType}
                        </span>
                    </div>*/}
                    {/*<Tag color={"blue"}>{item.postType}</Tag>*/}
                    <Tag className="post_type" color={"blue"}>{item.postType}</Tag>
                </div>
                <p className='postContent'>
                    {item.postContent}
                </p>
                <Divider className='postDivider' />
                <div className='postFooter'>
                    <div className='postFooter1'>
                        <div className='postEditor'>作者：{item.userName}</div>
                        <div className='postTime'>{item.createdTime.substring(0, 10)}</div>
                    </div>
                    <div className='postFooter2'>
                        <div className='postNum'>{item.viewCount}<span className='postPot'>浏览量</span></div>
                        <div className='postNum'>{item.comments}<span className='postPot'>评论</span></div>
                    </div>
                </div>
            </List.Item>
        )
    }

    _switchType = ({ item, key, keyPath, domEvent }) => {
        let selectType = ''
        let { inputValue, sortType } = this.state
        switch (key) {
            case 'all':
                selectType = ''
                break;
            case 'help':
                selectType = '求助'
                break;
            case 'discuss':
                selectType = '讨论'
                break;
            case 'course':
                selectType = '教程'
                break;
            case 'question':
                selectType = '问题'
                break;
            case 'others':
                selectType = '其他'
                break;
            default:
                break;
        }
        this.setState({ selectType: selectType })
        this._getPageOfPost(10, 1, inputValue, selectType, sortType)
    }

    _switchSortType = (doc) => {
        let type = doc.target.getAttribute('data-key')
        let { inputValue, selectType } = this.state
        switch (type) {
            case '时间':
                this._getPageOfPost(10, 1, inputValue, selectType, 'time')
                break;
            case '热度':
                this._getPageOfPost(10, 1, inputValue, selectType, 'hot')
                break;
            default:
                break;
        }
        this.setState({
            sortType: type
        })
    }

    _searchChange = (value = this.state.inputValue) => {
        this.setState({ inputValue: value.target.value })
        let { selectType, sortType } = this.state
        this._getPageOfPost(10, 1, value.target.value, selectType, sortType)
    }

    showModal = () => {
        this.setState({
            modalVisible: true,
        });
    };

    handleOk = e => {
        if (this.state.isLoading) {
            return; // 如果请求正在进行中，则不执行后续操作
        }
        this.setState({ isLoading: true });
        let { postTitle, postType, postContent } = this.state
        if(JudgingSpeech(postContent)) {
            message.error("请勿发表低俗、暴力、色情、政治、广告等违规信息！");
            this.setState({ isLoading: false });
            return
        }
        Axios({
            // 请求的 URL
            url: global.url.wd + "/post",
            // 请求方式
            method: 'post',
            // 发送的数据
            data: {
                postTitle: postTitle,
                postContent: postContent,
                postType: postType,
                userId: this.props.user.userId,//Number(getCookie('KEY_USERID')),
                userName: this.props.user.userName//getCookie('KEY_USERNAME')
            },
            // 请求头
            headers: { 'Authorization': this.props.user.token, }
        }).then((response) => {
            console.log(response)
            var msg = response.data.msg
            //发表成功
            if (response.data && response.data.code === 200) {
                this.setState({ postTitle: '', postType: '', postContent: '' })
                message.success(msg)
                window.location.reload();//刷新
                window.scrollTo(0, 0)//回到顶部
            } else {//发表失败
                message.error(msg)
            }
        }).catch(() => {
        })
        .finally(() => {
            this.setState({ isLoading: false }); // 请求完成后，重置请求状态
          });
    };

    handleCancel = e => {
        this.setState({ postTitle: '', postType: '', postContent: '',selectedValue: undefined,modalVisible: false, })
    };

    _handleChange = e => {
        this.setState({ postType: e,selectedValue: e  })
    }

    render() {
        let { sortType, inputValue, postTitle, postContent } = this.state
        return (
            <div>
                <Header4></Header4>
                <div className='QAMain'>
                    <div className='QAMainContainer'>
                        <div className='QAFunctionContainer'>
                            <Input
                                className='searchInput'
                                placeholder='检索相关帖子'
                                prefix={<img src={icon_search} className='searchImg' />}
                                value={inputValue}
                                onChange={value => this._searchChange(value)}
                                onPressEnter={() => this._searchChange()}
                            >
                            </Input>
                            <div className='QAFunctionContainer-right'>
                                <Badge dot={this.props.unReadMsg}>
                                    <span className='myActivit' onClick={() => this.props.history.push({
                                        pathname: '/Q&AMessage'
                                    })}>我的动态</span>
                                </Badge>
                                <Button
                                    type="primary"
                                    className='submitButton'
                                    icon={<img src={icon_add} style={{ width: '1.35rem' }} />}
                                    size='small'
                                    onClick={() => this.showModal()}
                                >
                                    发布
                                </Button>
                            </div>
                        </div>
                        <div className='QAContent'>
                            <div className='QAContentType'>
                                <Menu mode="vertical" defaultSelectedKeys={['all']} id='QAMenu' onClick={this._switchType} >
                                    <Menu.Item key="all" id='QAMenuItem' className="QAMenu">
                                        全部内容
                                    </Menu.Item>
                                    <Menu.Item key="help" id='QAMenuItem' className="QAMenu">
                                        求助专区
                                    </Menu.Item>
                                    <Menu.Item key="discuss" id='QAMenuItem' className="QAMenu">
                                        讨论专区
                                    </Menu.Item>
                                    <Menu.Item key="course" id='QAMenuItem' className="QAMenu">
                                        教程专区
                                    </Menu.Item>
                                    <Menu.Item key="question" id='QAMenuItem' className="QAMenu">
                                        问题反馈
                                    </Menu.Item>
                                    <Menu.Item key="others" id='QAMenuItem' className="QAMenu">
                                        其他类型
                                    </Menu.Item>
                                </Menu>
                            </div>
                            <div className='QAContentList'>
                                <div className='tabGroup'>
                                    <span className={sortType === '时间' ? 'activeTabs' : 'tabs'} onClick={key => this._switchSortType(key)} data-key='时间'>按时间</span>
                                    <span className={sortType === '热度' ? 'activeTabs' : 'tabs'} onClick={key => this._switchSortType(key)} data-key='热度'>按热度</span>
                                </div>
                                <div className='listContainer'>
                                    <List
                                        itemLayout="vertical"
                                        size="large"
                                        dataSource={this.state.postList}
                                        renderItem={this._renderPost}
                                        split={false}
                                        pagination={{
                                            onChange: page => {
                                                this.setState({page})
                                                this._getPageOfPost(10,page)
                                            },
                                            current: this.state.page,
                                            pageSize: 10,
                                            total:this.state.total
                                        }}
                                    >
                                    </List>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    title={null}
                    visible={this.state.modalVisible}
                    onCancel={this.handleCancel}
                    width='88rem'
                    footer={[
                        <Button key="back" onClick={() => this.handleCancel()}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={() => this.handleOk()}>
                            发布
                        </Button>,
                    ]}
                    maskClosable={false}
                    className='QAModal'
                >
                    <div className='modalBody'>
                        <Input className='titleInput' placeholder='请输入发布标题' value={postTitle} onChange={value => this.setState({ postTitle: value.target.value })}></Input>
                        <Select className='typeSelect'  placeholder="选择分类" value={this.state.selectedValue} onChange={this._handleChange} >
                            <Option value="求助">求助专区</Option>
                            <Option value="教程">教程专区</Option>
                            <Option value="讨论">讨论专区</Option>
                            <Option value="问题">问题反馈</Option>
                            <Option value="其他">其他类型</Option>
                        </Select>
                        <TextArea id='postInput' autoSize={{ minRows: 13 }} value={postContent} onChange={value => this.setState({ postContent: value.target.value })}></TextArea>
                    </div>
                </Modal >
            </div >
        )
    }
}

const mapState = (state) => ({
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS(),
    unReadMsg: state.userReducer.get('userMsg')
})
const mapDispatch = () => ({

})
export default connect(mapState, mapDispatch)(QACenter);